import { SEO } from "@/components/SEO";
import { headTageTitle } from "@/utils/head-tag-title";
import { getConfigSSR } from "api/config";
import { useMemo } from "react";
import { useAppSelector } from "store/hooks";
import { ConfigPage, NextPageWithLayoutAndPageType } from "types/index";

const ContactPage: NextPageWithLayoutAndPageType = (props: any) => {
  const storeConfig = useAppSelector((state) => state.config);
  const config = props.config || storeConfig;
  const siteTitleFromHeadTag = useMemo(() => headTageTitle(config), [config]);

  const siteName = siteTitleFromHeadTag
    ? siteTitleFromHeadTag
    : config.company_info?.name;
  const seoconfig = config.pages?.find(
    (page: ConfigPage) => page?.page_type === "contact",
  )?.config;
  const description =
    seoconfig?.description ||
    `Get in touch with ${siteName}. Find our location, contact information, and business hours. We're here to help with your movie booking needs.`;
  const title = seoconfig?.title || "Contact Us";
  const keywords = seoconfig?.keywords || [
    "contact",
    "location",
    "phone",
    "email",
    "support",
    siteName,
  ];

  return (
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      siteName={siteName}
    />
  );
};

ContactPage.page_type = "contact";
export const getServerSideProps = getConfigSSR;

export default ContactPage;
